import maxLatinChars from '../../../../../form/field-validation/maxLatinChars';
import {isATaxableDeliveryOptionSelected} from '../../../../../selectors/DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import store from '../../../../../store/store';

export default (fieldName, max) => (value) => {
  const hasMaxLatinChars = maxLatinChars(fieldName, max);
  return isATaxableDeliveryOptionSelected(store.getState()) ? hasMaxLatinChars(value) : undefined;
};
